/**
 * Contact-capture taxonomy + control (ADR-0026).
 *
 * `CAPTURE_POINTS` is the SINGLE source of truth for WHERE in the funnel a
 * contact is captured. Every `contact_captured` emitter stamps one of these as
 * `capture_point`, so the capture-rate of each point is a first-class, day-wise
 * measurable signal in `events_raw` (rule 34 → beacon → BigQuery). Before this
 * the chat-inline capture emitted no placement at all, so a form-vs-value-moment
 * comparison was incomplete/unmeasurable.
 *
 * Day-wise measurement (LLM-first BI — query on demand, no dashboard):
 *
 *   SELECT DATE(occurred_at) AS day,
 *          JSON_VALUE(properties, '$.capture_point') AS capture_point,
 *          COUNT(*) AS captures,
 *          COUNTIF(JSON_VALUE(properties, '$.consent_marketing') = 'true') AS marketing_opt_ins
 *   FROM ishvaram_warehouse.events_raw            -- (or stg_events_raw)
 *   WHERE event_name = 'contact_captured'
 *   GROUP BY day, capture_point ORDER BY day DESC, captures DESC;
 *
 * A full A/B BETWEEN capture points stays DEFERRED until ~50 purchases/day
 * (ADR-0020). This taxonomy is measurement scaffolding, not an experiment
 * toggle.
 */
export const CAPTURE_POINTS = {
  /** Required phone (+ optional email) on the chat-entry birth-details form —
   *  captures the seeker BEFORE message 1 so the contact lands ahead of the chat
   *  soft-wall without granting recurring-message consent. */
  KUNDALI_FORM_CONTACT: "kundali_form_contact",
  /** Post-result opt-in on a saved value surface (kundali / match reading). */
  VALUE_MOMENT: "value_moment",
  /** Inline ask inside the chat reading conversation. */
  CHAT_INLINE: "chat_inline",
} as const;

export type CapturePoint = (typeof CAPTURE_POINTS)[keyof typeof CAPTURE_POINTS];
